import React from 'react';

import { Grid } from '@material-ui/core';
import { TextField, CheckField, AddressField, SwitchField, Step } from '../SteppedForm';

import rules from './rules';

const StepCompany = (props) => {
  return (
    <Step
      id="company"
      title={(props.state.formdata.orgtype === 'company' ? 'Company' : 'Partnership') + ' Details'}
      skip={(formdata) =>
        formdata.orgtype === 'individual' || formdata.onboardingFor === 'vehicle'
      }>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField
            id="orgname"
            label={
              (props.state.formdata.orgtype === 'company' ? 'Company' : 'Partnership') + ' Name'
            }
            help={`The registered name of your ${props.state.formdata.orgtype}.`}
            valid={rules.safeText}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="trading_as"
            label="Trading As"
            help={`Any other trading name for your ${props.state.formdata.orgtype}.`}
            valid={rules.safeText}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="composite">
            <TextField
              id="correspondname"
              label="Correspondance Name"
              suppressOptional
              value={
                props.state.formdata.name_as_correspondance
                  ? props.state.formdata.orgname
                  : props.state.formdata.correspondname
              }
              valid={(v) =>
                !(props.state.formdata.correspondname || props.state.formdata.name_as_correspondance)
                  ? 'Is a required field'
                  : rules.safeText.valid(v) || rules.safeText.message
              }
              disabled={props.state.formdata.name_as_correspondance}
              help="The name of the person who should receive any communications."
            />
            <SwitchField
              id="name_as_correspondance"
              label={
                'Use ' +
                (props.state.formdata.orgtype === 'company' ? 'Company' : 'Partnership') +
                ' Name'
              }
              color="secondary"
              checked={props.state.formdata.name_as_correspondance ? true : false}
            />
          </div>
        </Grid>

        <Grid item xs={12} lg={6}>
          <TextField
            id="orgabn"
            label="ABN (without spaces)"
            valid={rules.abn}
            modify={(value) => props.limitLength(value, 11)}
            required
          />
        </Grid>

        {props.state.formdata.orgtype === 'company' && (
          <Grid item xs={12} lg={6}>
            <TextField
              id="acn"
              label="ACN (Without Spaces)"
              valid={rules.acn}
              modify={(value) => props.limitLength(value, 9)}
              required
            />
          </Grid>
        )}

        {props.stateconfig().stateid && (
          <Grid item xs={props.state.formdata.orgtype === 'company' ? 6 : 12}>
            <TextField id="org_crn" label={props.stateconfig().stateid} valid={rules.safeText} />
          </Grid>
        )}

        <Grid item xs={12} lg={6}>
          <AddressField
            id="hqaddress"
            label="Registered Address"
            country="AU"
            help={`The registered address of your ${props.state.formdata.orgtype}.`}
            fetchDetails
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <div className="composite">
            <AddressField
              id="opaddress"
              label="Operational Address"
              country="AU"
              fetchDetails
              suppressOptional
              value={
                props.state.formdata.op_as_hq
                  ? props.state.formdata.hqaddress
                  : props.state.formdata.opaddress
              }
              valid={(v) =>
                props.state.formdata.opaddress || props.state.formdata.op_as_hq
                  ? true
                  : 'Is a required field'
              }
              disabled={props.state.formdata.op_as_hq}
              help={`The address of where your ${props.state.formdata.orgtype} operates. Eg, where your Taxis are kept when not on the road.`}
            />
            <SwitchField
              id="op_as_hq"
              label="Use Registered Address"
              color="secondary"
              checked={props.state.formdata.op_as_hq ? true : false}
            />
          </div>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="orgphone"
            label="Phone"
            type="tel"
            inputProps={{ maxLength: 16 }}
            valid={rules.phone}
            help={`The registered phone number of your ${props.state.formdata.orgtype}.`}
            required
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="orgemail"
            label="Email"
            valid={rules.email}
            help={`"The registered email address of your ${props.state.formdata.orgtype}.`}
            required
          />
        </Grid>
        <Grid item className="centered" xs={12}>
          <CheckField
            id="gst"
            label={`Is your ${props.state.formdata.orgtype} registered for GST with the ATO?`}
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepCompany;
